'use strict';

/**
 * @ngdoc service
 * @name mx.components.MxLodash
 * @module mx.components
 *
 * @description
 * Simple replacement of Lodash component
 *
 * */
var MxLodash = function () {};

MxLodash.prototype = (function () {
	var result = {
		map: map,
		filter: filter,
		find: find,
		findIndex: findIndex,
		intersection: intersection,
		some: some,
		groupBy: groupBy,
		findKey: findKey,
		remove: remove,
		set: set,
		forEach: forEach,
		forOwn: forOwn,
		forIn: forIn,
		get: get,
		merge: merge,
		maxBy: maxBy,
		minBy: minBy,
		first: first,
		values: values,
		uniqBy: uniqBy,
		uniq: uniq,
		mapValues: mapValues,
		isEqual: isEqual,
		sortBy: sortBy,
		invert: invert,
		isEmpty: isEmpty,
	};

	return result;

	function invert(obj) {
		var res = {};
		if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
			forOwn(obj, function (value, key) {
				res[value] = key;
			});
			return res;
		}
		return null;
	}

	function uniq(array) {
		return uniqBy(array);
	}

	function get(obj, path) {
		return obj === null || obj === undefined ? obj : _getAndSet(obj, path);
	}

	function _getAndSet(obj, path, isSet, val) {
		path = path.split('.');
		var len = path.length;
		for (var i = 0; i < len; i++) {
			if (i === len - 1 && isSet) {
				obj[path[i]] = val;
			} else {
				var n = obj[path[i]];
				if (!n) {
					if (isSet) {
						n = {};
						obj[path[i]] = n;
					} else {
						return null;
					}
				}
				obj = n;
			}
		}

		return obj;
	}

	function set(obj, path, val) {
		_getAndSet(obj, path, true, val);
	}

	function mapValues(obj, func) {
		var res = {};
		var isF = typeof func === 'function';
		forIn(obj, function (val, name) {
			res[name] = isF ? func(val) : val[func];
		});
		return res;
	}

	function uniqBy(arr, func) {
		if (!arr || arr.length === 0) {
			return [];
		}
		var res = [];
		forIn(groupBy(arr, func), function (lst) {
			res.push(lst[0]);
		});
		return res;
	}

	function groupBy(arr, func) {
		var res = {};
		_iterateCollection(arr, func, function (obj, val) {
			var lst = res[val];
			if (!lst) {
				res[val] = [obj];
			} else {
				lst.push(obj);
			}
		});
		return res;
	}

	function minBy(arr, func) {
		return baseExtremum(arr, getIteratee(func), function (x, y) {
			return x < y;
		});
	}

	function maxBy(arr, func) {
		return baseExtremum(arr, getIteratee(func), function (x, y) {
			return x > y;
		});
	}

	function baseExtremum(array, iteratee, comparator) {
		var index = -1;
		var length = array.length;
		var computed;
		var res;

		while (++index < length) {
			var value = array[index];
			var current = iteratee(value);

			if (current !== null && current !== undefined && (computed === undefined ? true : comparator(current, computed))) {
				computed = current;
				res = value;
			}
		}
		return res;
	}

	function getIteratee(conditionObj) {
		if (!conditionObj) {
			return function (obj) {
				return obj;
			};
		}

		if (typeof conditionObj === 'function') {
			return conditionObj;
		} else if (typeof conditionObj === 'string') {
			return function (obj) {
				if (!obj) {
					return undefined;
				}

				if (conditionObj.indexOf('.') === -1) {
					return obj[conditionObj];
				}

				return get(obj, conditionObj);
			};
		} else if (typeof conditionObj === 'object') {
			return function (item) {
				return !some(Object.keys(conditionObj), function (key) {
					return item[key] !== conditionObj[key];
				});
			};
		}
	}

	function _prepareArray(obj) {
		if (!obj) {
			return [];
		}
		if (Array.isArray(obj)) {
			return obj;
		}
		if (typeof obj === 'object') {
			return Object.keys(obj).map(function (key) {
				return obj[key];
			});
		}
		return [];
	}

	function _iterateCollection(arr, func, execFunc) {
		for (var i = 0; i < arr.length; i++) {
			var obj = arr[i];
			execFunc(obj, getIteratee(func)(obj), i);
		}
	}

	function merge(obj, source) {
		if (obj === null || obj === undefined || typeof obj !== 'object') {
			return obj;
		}
		if (source === null || source === undefined || typeof source !== 'object') {
			return obj;
		}
		return _mergeRecursively(obj, source, [], []);
	}

	function _mergeRecursively(target, source, seenSources, seenTargets) {
		var seenIndex = seenSources.indexOf(source);
		if (seenIndex >= 0) {
			return seenTargets[seenIndex];
		}

		seenSources.push(source);
		seenTargets.push(target);

		forOwn(source, function (value, key) {
			if (key === '__proto__' || key === 'prototype' || key === 'constructor') {
				return;
			}

			var desc = Object.getOwnPropertyDescriptor(target, key);
			if (desc && typeof desc.set === 'function') {
				target[key] = _isPlainObject(value) && !!target[key] ? _mergeRecursively(target[key], value, seenSources, seenTargets) : value;
				return;
			}

			if (Array.isArray(value)) {
				var baseArr = Array.isArray(target[key]) ? target[key] : [];
				target[key] = _mergeArray(baseArr, value, seenSources, seenTargets);
				return;
			}

			if (_isPlainObject(value)) {
				var baseObj = _isPlainObject(target[key]) ? target[key] : {};
				target[key] = _mergeRecursively(baseObj, value, seenSources, seenTargets);
				return;
			}

			target[key] = value;
		});

		return target;
	}

	function _mergeArray(target, source, seenSources, seenTargets) {
		var seenIndex = seenSources.indexOf(source);
		if (seenIndex >= 0) {
			return seenTargets[seenIndex];
		}

		seenSources.push(source);
		seenTargets.push(target);

		for (var i = 0; i < source.length; i++) {
			var value = source[i];

			if (Array.isArray(value)) {
				var baseArr = Array.isArray(target[i]) ? target[i] : [];
				target[i] = _mergeArray(baseArr, value, seenSources, seenTargets);
				continue;
			}

			if (_isPlainObject(value)) {
				var baseObj = _isPlainObject(target[i]) ? target[i] : {};
				target[i] = _mergeRecursively(baseObj, value, seenSources, seenTargets);
				continue;
			}

			target[i] = value;
		}

		return target;
	}

	function _isPlainObject(value) {
		return value !== null && typeof value === 'object' && !Array.isArray(value) && Object.prototype.toString.call(value) === '[object Object]';
	}

	function findKey(obj, func) {
		var valsArr = [];
		var propArr = [];

		forIn(obj, function (propVal, propName) {
			valsArr.push(propVal);
			propArr.push(propName);
		});

		var inx = _find(valsArr, func);
		return inx >= 0 ? propArr[inx] : undefined;
	}

	function forIn(obj, func) {
		for (var p in obj) {
			func(obj[p], p);
		}
	}

	function forOwn(obj, func) {
		for (var p in obj) {
			if (obj.hasOwnProperty(p)) {
				func(obj[p], p);
			}
		}
	}

	function remove(arr, func) {
		var removed = [];

		for (var i = arr.length - 1; i >= 0; i--) {
			if (func(arr[i])) {
				removed.push(arr[i]);
				arr.splice(i, 1);
			}
		}

		return removed;
	}

	function values(obj) {
		var res = [];
		for (var i in obj) {
			res.push(obj[i]);
		}
		return res;
	}

	function first(arr) {
		return arr[0];
	}

	function map(arr, func) {
		if (!arr) {
			return [];
		}
		arr = Array.isArray(arr) ? arr : [];
		return arr.map(getIteratee(func));
	}

	function forEach(arr, func) {
		if (Array.isArray(arr)) {
			arr.forEach(func);
		} else {
			forIn(arr, func);
		}
	}

	function filter(arr, func) {
		arr = Array.isArray(arr) ? arr : [];
		return arr.filter(getIteratee(func));
	}

	function find(arr, func) {
		arr = _prepareArray(arr);
		var inx = _find(arr, func);
		return inx >= 0 ? arr[inx] : undefined;
	}

	function findIndex(arr, func) {
		return _find(arr, func);
	}

	function _find(arr, func) {
		var arrCond = [];
		var callFunc = false;
		var funcType = typeof func;
		if (funcType === 'object') {
			if (Array.isArray(func)) {
				arrCond = func;
			} else {
				forIn(func, function (val, name) {
					arrCond.push(name);
					arrCond.push(val);
				});
			}
		} else if (funcType === 'function') {
			callFunc = true;
		} else if (funcType === 'string') {
			arrCond.push(func);
			arrCond.push(true);
		} else {
			return -1;
		}

		for (var i = 0; i < arr.length; i++) {
			var obj = arr[i];
			if (obj) {
				if (callFunc) {
					if (func(obj)) {
						return i;
					}
				} else {
					var cont = false;
					for (var j = 0; j < arrCond.length; j = j + 2) {
						if (obj[arrCond[j]] !== arrCond[j + 1]) {
							cont = true;
							continue;
						}
					}
					if (cont) {
						continue;
					}

					return i;
				}
			}
		}
		return -1;
	}

	function intersection(arr1, arr2) {
		return arr1.filter(function (n) {
			return arr2.indexOf(n) !== -1;
		});
	}

	function some(arr, func) {
		if (!arr) {
			return false;
		}
		return arr.some(getIteratee(func));
	}

	function isEqual(a, b) {
		return angular.equals(a, b);
	}

	function sortBy(arr, prop) {
		arr.sort(function (a, b) {
			if (a[prop] < b[prop]) {
				return -1;
			} else if (a[prop] > b[prop]) {
				return 1;
			} else {
				return 0;
			}
		});
	}

	function isEmpty(value) {
		if (value === null) return true;
		if (typeof value === 'string' && value.trim() === '') return true;
		if (Array.isArray(value) && value.length === 0) return true;
		if (typeof value === 'object') {
			return Object.keys(value).length === 0;
		}
		return false;
	}
})();

const lodash = new MxLodash();

if (!window._) {
	window._ = lodash;
}

export default lodash;
